module.exports = __webpack_public_path__ + "019cfacb67371b6b8caa676bc3614db6.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/PY.svg
// module id = 9qeh
// module chunks = 0